import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Paper, Typography, makeStyles } from "@material-ui/core";
import { Panel } from "../../../panel";
import { addRegisteredLayout } from "../layoutDescriptions";
import { ThemeProvider } from "@material-ui/core/styles";
import { useStyles, actionsTheme } from "./styles";
import clsx from "clsx";
import FormStatus from "../../../components/FormStatus";
import { useAppLoad } from "../../../appLoadContext";
const customerInfoSettings = {
    editableOptions: {
        title: false,
        elevation: true,
        square: true
    }
};
const column1PanelSettings = {
    editableOptions: {
        title: true,
        elevation: true,
        square: true
    }
};
const column2PanelSettings = {
    editableOptions: {
        title: true,
        elevation: true,
        square: true
    }
};
const column3PanelSettings = {
    editableOptions: {
        title: true,
        elevation: true,
        square: true
    }
};
const summaryHeaderPanelSettings = {
    editableOptions: {
        title: false,
        elevation: true,
        square: true,
    }
};
const actionsPanelSettings = {
    editableOptions: {
        title: false,
        elevation: true,
        square: true,
    }
};
const panels = {
    summaryHeader: summaryHeaderPanelSettings,
    customerInfo: customerInfoSettings,
    column1: column1PanelSettings,
    column2: column2PanelSettings,
    column3: column3PanelSettings,
    actions: actionsPanelSettings
};
addRegisteredLayout({
    name: "ThreeColumnsWithCustomerSectionOnTop",
    displayName: "ThreeColumnsWithCustomerSectionOnTop",
    panels
});
const useThreeColumnsWithCustomerSectionOnTopStyle = makeStyles(theme => ({
    twoColumnPadding: {
        padding: 0
    }
}));
export function ThreeColumnsWithCustomerSectionOnTop(props) {
    const classes = useStyles(props);
    const threeColumnsWithCustomerSectionOnTopStyle = useThreeColumnsWithCustomerSectionOnTopStyle(props);
    const { header, panels } = props;
    const { summaryHeader, customerInfo, column1, column2, column3, actions } = panels;
    const { vulcanContext } = useAppLoad();
    const sameHeight = {
        height: "100%"
    };
    return (_jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(FormStatus, {}) }), _jsx(Grid, { item: true, md: 12, xs: 12, children: customerInfo && (_jsx(Paper, { children: _jsx(Panel, { ...customerInfo, elevation: 0 }) })) }), _jsx(Grid, { item: true, xs: 12, container: true, children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { md: 8, item: true, children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, md: 6, children: _jsx("div", { style: sameHeight, children: _jsx(Grid, { item: true, xs: 12, style: sameHeight, children: column1 && (_jsxs(Paper, { style: sameHeight, children: [column1.panelTitle && (_jsx(Typography, { variant: "h6", className: classes.mainSectionsHeader, children: column1.panelTitle })), _jsx(Panel, { className: clsx(classes.mainSections, threeColumnsWithCustomerSectionOnTopStyle.twoColumnPadding), ...column1 })] })) }) }) }), _jsx(Grid, { item: true, md: 6, children: _jsx("div", { style: sameHeight, children: _jsx(Grid, { item: true, xs: 12, style: sameHeight, children: column2 && (_jsxs(Paper, { style: sameHeight, children: [column2.panelTitle && (_jsx(Typography, { variant: "h6", className: classes.mainSectionsHeader, children: column2.panelTitle })), _jsx(Panel, { className: clsx(classes.mainSections, threeColumnsWithCustomerSectionOnTopStyle.twoColumnPadding), elevation: 0, ...column2 })] })) }) }) })] }) }), _jsx(Grid, { md: 4, item: true, children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, xs: 12, children: column3 && (_jsxs(Paper, { children: [column3.panelTitle && (_jsx(Typography, { variant: "h6", className: classes.mainSectionsHeader, children: column3.panelTitle })), _jsx(Panel, { elevation: 0, className: clsx(classes.mainSections, threeColumnsWithCustomerSectionOnTopStyle.twoColumnPadding), ...column3 })] })) }), _jsx(Grid, { item: true, xs: 12, children: actions && vulcanContext !== "PostProcess" && (_jsx(ThemeProvider, { theme: actionsTheme, children: _jsx(Panel, { elevation: 0, className: clsx(classes.mainSections, threeColumnsWithCustomerSectionOnTopStyle.twoColumnPadding), ...actions }) })) })] }) })] }) })] }));
}
//# sourceMappingURL=ThreeColumnsWithCustomerSectionOnTop.js.map